<kpd-detail-entity-tabs
  [facade]="permissionFacade"
  [navigatorHelper]="navigatorHelper"
  (close)="onClose()"
  (itemChanged)="onItemChanged($event.item)"
  [viewMode]="true"
  [entityTypeName]="'Permission' | translate"
>
  <kpd-detail-tab [title]="'General' | translate" name="general">
    <ng-template>
      <app-permission-set-details-general
        [item]="currentItem"
        (itemChanged)="onItemChanged($event)"
      ></app-permission-set-details-general>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Permissions Sets' | translate"
    name="permissionsets"
    icon="unlock"
    [badge]="!!tabLabels.permissionSetCount ? tabLabels.permissionSetCount.toString() : ''"
  >
    <ng-template>
      <app-permission-details-permissionsets
        (permissionSetCountChanged)="changeTabLabel('permissionSetCount', $event)"
        [permission]="currentItem"
      ></app-permission-details-permissionsets>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Roles' | translate"
    name="roles"
    icon="users"
    [badge]="!!tabLabels.rolesCount ? tabLabels.rolesCount.toString() : ''"
  >
    <ng-template>
      <app-permission-details-roles
        [permission]="currentItem"
        (roleCountChanged)="changeTabLabel('rolesCount', $event)"
      ></app-permission-details-roles>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Users' | translate"
    name="users"
    icon="user"
    [badge]="!!tabLabels.usersCount ? tabLabels.usersCount.toString() : ''"
  >
    <ng-template>
      <app-permission-details-users
        [permission]="currentItem"
        (userCountChanged)="changeTabLabel('usersCount', $event)"
      ></app-permission-details-users>
    </ng-template>
  </kpd-detail-tab>
</kpd-detail-entity-tabs>
